/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListContractsRequest = {
  properties: {
    hirerId: {
      type: 'string',
    },
    professionalId: {
      type: 'string',
    },
    id: {
      type: 'string',
    },
  },
} as const;
